import { IServerStateCommon, ServerStateType, THomePageVersion } from 'base/store/serverStore';
import { IPersistClientKeys } from 'mod/store/clientKeys/interface';
import { getPersistClientKeys } from 'mod/store/clientKeys/utils';
import { IReferralConfig } from 'mod/referral/interface';

export type PersistStateType = Omit<IServerStateCommon, 'uriMapList'> & {
    navList: ServerStateType['navList'][string];
    topStripedBanner: ServerStateType['topStripedBanner'][string];
    topPromotionBar: ServerStateType['topPromotionBar'][string];
    tagTheme: ServerStateType['tagTheme'][string];
    clientKeys: IPersistClientKeys;
    referralConfig: IReferralConfig;
    homePageVersion: THomePageVersion;
}

export type PersistStoreType = {
    state: PersistStateType;
    getPersistState: (serverState: ServerStateType, lang: string, country: string) => void;
    update: (newState?: Partial<PersistStateType>) => void;//更新state
}

const createPersistStore = (state: PersistStateType): PersistStoreType => {
    return {
        state,
        getPersistState(serverState, lang, country) {
            const locale = `${lang}-${country}`;
            const {
                uriMapList, //排除
                navList,
                topStripedBanner,
                topPromotionBar,
                tagTheme,
                clientKeys,
                referralConfig,
                homePageVersions,
                ...rest
            } = serverState;

            this.state = {
                ...rest,
                navList: navList[locale],
                topStripedBanner: topStripedBanner[locale],
                topPromotionBar: topPromotionBar[locale],
                tagTheme: tagTheme[locale],
                clientKeys: getPersistClientKeys(clientKeys, country),
                referralConfig: referralConfig[country] as IReferralConfig,
                homePageVersion: homePageVersions[country] as THomePageVersion
            }
        },
        update(newState) {
            if (newState) {
                for (const key in newState) {
                    const storeKey = key as keyof PersistStateType;
                    // @ts-ignore
                    this.state[storeKey] = newState[storeKey];
                }
            }
        },
    };
};

export default createPersistStore;